import { TEXT_SDQ_REPORT } from 'constants/string/texts';
import {
  buildAllLowSection6Data,
  buildBr07SectionData,
  buildFutureStrengthSectionData,
  buildStrengthsSectionData,
  buildWorkingHardSectionData,
} from 'utils/sdqAnalysis';

import SdqRiskDetailSection from './SdqRiskDetailSection';
import SdqSectionTitleBar from './SdqSectionTitleBar';
import SdqStrengthIntroLine from './SdqStrengthIntroLine';

const TITLE_STRENGTH_CLASS = 'bg-sdq-strength';
const TITLE_MODERATE_CLASS = 'bg-sdq-moderate';
const TITLE_HIGH_CLASS = 'bg-sdq-high';

/**
 * The new SDQ report body, identical in content and ordering to the guardian app
 * (`SdqNewReportSections`). Which sections appear depends on the risk levels:
 *  - mixed   : 上手にできていること / 頑張っていること (moderate) / これからのびる力 (high)
 *  - all low : 上手にできていること / 頑張っていること (weakest subscale)
 *  - BR07    : 頑張っていること (highest scores) / これからのびる力
 * Every builder returns null when it does not apply, so nothing is rendered twice.
 */
const SdqNewReportSections = (props) => {
  const { analysisResults } = props;

  const strengthsData = buildStrengthsSectionData(analysisResults);
  const br07Data = buildBr07SectionData(analysisResults);
  const workingHardData = buildWorkingHardSectionData(analysisResults);
  const allLowData = buildAllLowSection6Data(analysisResults);
  const futureStrengthData = buildFutureStrengthSectionData(analysisResults);

  return (
    <>
      {strengthsData && (
        <div className="mt-6 space-y-3">
          <SdqSectionTitleBar className={TITLE_STRENGTH_CLASS}>
            <p className="font-bold text-black-102">{TEXT_SDQ_REPORT.STRENGTHS_TITLE}</p>
          </SdqSectionTitleBar>
          <div className="space-y-4 text-sm text-black-102">
            <SdqStrengthIntroLine subscaleKeys={strengthsData.introSubscaleKeys} />
            {strengthsData.items.map((item) => (
              <div key={item.subscaleKey} dangerouslySetInnerHTML={{ __html: item.html }} />
            ))}
          </div>
        </div>
      )}

      {br07Data && (
        <div className="mt-6 space-y-3">
          <SdqSectionTitleBar className={TITLE_MODERATE_CLASS}>
            <p className="font-bold text-black-102">{TEXT_SDQ_REPORT.WORKING_HARD_TITLE}</p>
          </SdqSectionTitleBar>
          <div className="space-y-4 text-sm text-black-102">
            <SdqStrengthIntroLine subscaleKeys={br07Data.introSubscaleKeys} variant="br07" />
            {br07Data.characteristicHtml && <div dangerouslySetInnerHTML={{ __html: br07Data.characteristicHtml }} />}
          </div>
        </div>
      )}

      {workingHardData && (
        <SdqRiskDetailSection
          sectionData={workingHardData}
          title={TEXT_SDQ_REPORT.WORKING_HARD_TITLE}
          titleClassName={TITLE_MODERATE_CLASS}
          solutionLabel={TEXT_SDQ_REPORT.WORKING_HARD_SOLUTION_LABEL}
          behaviorFooter={TEXT_SDQ_REPORT.WORKING_HARD_BEHAVIOR_FOOTER}
        />
      )}

      {allLowData && (
        <SdqRiskDetailSection
          sectionData={allLowData}
          title={TEXT_SDQ_REPORT.WORKING_HARD_TITLE}
          titleClassName={TITLE_MODERATE_CLASS}
          solutionLabel={TEXT_SDQ_REPORT.WORKING_HARD_SOLUTION_LABEL}
          behaviorFooter={TEXT_SDQ_REPORT.WORKING_HARD_BEHAVIOR_FOOTER}
        />
      )}

      {futureStrengthData && (
        <SdqRiskDetailSection
          sectionData={futureStrengthData}
          title={TEXT_SDQ_REPORT.FUTURE_STRENGTH_TITLE}
          titleClassName={TITLE_HIGH_CLASS}
          solutionLabel={TEXT_SDQ_REPORT.FUTURE_STRENGTH_SOLUTION_LABEL}
          behaviorFooter={TEXT_SDQ_REPORT.FUTURE_STRENGTH_BEHAVIOR_FOOTER}
        />
      )}
    </>
  );
};

export default SdqNewReportSections;
